import type { FC } from "react";

import { GetUpdatesDialog } from "~/feature/getUpdates/components/GetUpdatesDialog";
import { LifetimePremiumContent } from "~/feature/getUpdates/components/LifetimePremiumContent";
import { useGetUpdatesTriggers } from "~/feature/getUpdates/hooks/useGetUpdatesTriggers";

export const GetUpdatesAutoDialog: FC = () => {
  const { open, handleClose } = useGetUpdatesTriggers();

  return (
    <GetUpdatesDialog open={open} onClose={handleClose}>
      <LifetimePremiumContent onClose={handleClose} />
    </GetUpdatesDialog>
  );
};
